module.exports = __webpack_public_path__ + "static/Inter-Bold-28d6d6cfda18527d91ab29414a1ef93a.woff";